import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsAPI } from '../utils/api';

const usePageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    analyticsAPI.trackVisit(location.pathname);
  }, [location.pathname]);
};

export default usePageTracker;
